import { FormElement, formService } from '@common';
import { MaxiNetCalendarField } from './lib/modules/maxi-net/components';

formService.registerFormElement('maxiNetCalendar', {
  class: FormElement,
  componentClass: MaxiNetCalendarField
});

// models
export * from './lib/models';

// composables
export * from './lib/composables';

// services
export * from './lib/services';

// stores
export * from './lib/store';

// utils
export * from './lib/utils';

// components
export * from './lib/components';

// modules
export * from './lib/modules/colormap';
export * from './lib/modules/fertilizer';
export * from './lib/modules/geo-layers-upload';
export * from './lib/modules/map';
export * from './lib/modules/monitoring';
export * from './lib/modules/parcel';
export * from './lib/modules/pesticide';
export * from './lib/modules/plan';
export * from './lib/modules/seed';
export * from './lib/modules/substance-databases';
export * from './lib/modules/statistics';
export * from './lib/modules/decision-support';
export * from './lib/modules/heightmap';
export * from './lib/modules/maxi-net';
